<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.name"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="IP address"
      name="IP address"
      placeholder="203.152.11.51"
      v-model="model.address"
      v-validate="rules.address"
      :error-messages="errors.collect('IP address')"
      @input="sendData"></gg-text-field>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'ARecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        address: ''
      },
      rules: {
        name: { required: true },
        ttl: { required: true, numeric: true },
        address: { required: true, ip: true }
      }
    }
  },
  methods: {
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    // If props "edit" is true, it`s mean that we use current component for editing record, then execute next function
    if (this.edit) {
      this.fillEditData()
    }
    this.sendData()
  }
}
</script>
